import { Stack, Text } from "@certn/cascadia";
import { List, ListItem, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function WwccLimitationsMessage() {
  const { t } = useTranslation();

  return (
    <SectionMessage
      type="info"
      icon="info"
      sectionTitle={t("WWCC Verification Limitations")}
      testID="wwcc-verification-limitations"
      fontSize="md"
    >
      <Stack gap="space-2">
        <Text style="global/body-secondary">
          {t("Certn cannot verify Working With Children Checks issued by:")}
        </Text>
        <List type="unordered">
          <ListItem>
            <Text style="global/body-secondary">
              {t("Australian Capital Territory (ACT)")}
            </Text>
          </ListItem>
          <ListItem>
            <Text style="global/body-secondary">
              {t("New South Wales (NSW)")}
            </Text>
          </ListItem>
        </List>
        <Text style="global/body-secondary">
          {t(
            "If an applicant submits a WWCC from these states, the check will be cancelled at no cost."
          )}
        </Text>
      </Stack>
    </SectionMessage>
  );
}
